module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst clazz = (formMapping || {}).class || ''\nlet classes = ['row']\nif(utils.isArray(clazz)){\nclasses = classes.concat(clazz)\n} else if(typeof clazz === 'string') {\nclasses = classes.concat(clazz.trim().split(' '))\n}\n%><div class=\"<%- classes.join(' ') %>\"><%\nutils.forEach(formMapping.content || [], function(element){\n%><%- include(element.type, { formMapping: element, model: model, config: config }); %><%\n})\n%></div>"
  , __filename = "..\\frontend-controller\\baseComponents\\bootstrap5\\form\\elements\\row.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const clazz = (formMapping || {}).class || ''
let classes = ['row']
if(utils.isArray(clazz)){
classes = classes.concat(clazz)
} else if(typeof clazz === 'string') {
classes = classes.concat(clazz.trim().split(' '))
}

    ; __line = 9
    ; __append("<div class=\"")
    ; __append( classes.join(' ') )
    ; __append("\">")
    ; 
utils.forEach(formMapping.content || [], function(element){

    ; __line = 11
    ; __append( include(element.type, { formMapping: element, model: model, config: config }) )
    ; 
})

    ; __line = 13
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\bootstrap5\form\elements\row.ejs

}